import { render, staticRenderFns } from "./KreirajLigu.vue?vue&type=template&id=02a81b5e&scoped=true&"
import script from "./KreirajLigu.vue?vue&type=script&lang=js&"
export * from "./KreirajLigu.vue?vue&type=script&lang=js&"
import style0 from "./KreirajLigu.vue?vue&type=style&index=0&id=02a81b5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a81b5e",
  null
  
)

export default component.exports